import { TypeGuards } from '@services/type-guards'

import { L3OnboardingFields } from '../../..'

import type { CountryCode } from '@shared/graphql'

/**
 * Post code schema
 * required when Usa or Canada.
 */
export const postCodeSchema = (name = 'country') =>
  L3OnboardingFields.Utils.copStringSchema.when(
    name,
    (countryField: CountryCode[], schema) => {
      if (TypeGuards.Common.isUsaOrCanada(countryField[0])) {
        return schema.postalCode().required()
      }

      return schema
    },
  )
